// @flow
import React, { Fragment } from 'react';
import BrandHead from 'components/brand/BrandHead';
import BrandContent from '../BrandContent';
import './BrandPlaceholder.scss';

type Props = {};

const BrandPlaceholder = (props: Props) => (
  <Fragment>
    <BrandHead.Placeholder />
    <BrandContent.Placeholder />
  </Fragment>
);

export default BrandPlaceholder;



// WEBPACK FOOTER //
// ./src/components/brand/BrandPlaceholder/BrandPlaceholder.js